import React from 'react';

import API from 'utils/api';

import {
  groupSelectionKey,
  groupUuidsOf,
  PickerItemKind,
  PickerValue,
} from 'components/SharedFormComponents/UserAndGroupPicker';
import LicenceCoverageNotice, {
  LicenceNoticeSurface,
} from 'components/SharedFormComponents/UserAndGroupPicker/LicenceCoverageNotice';
import useGroupLicencePreview from 'components/SharedFormComponents/UserAndGroupPicker/useGroupLicencePreview';

interface GroupLicenceNoticeProps {
  value: PickerValue[];
  savedValue?: PickerValue[];
  'data-testid'?: string;
}

const GroupLicenceNotice: React.FunctionComponent<GroupLicenceNoticeProps> = ({
  value,
  savedValue,
  'data-testid': dataTestId,
}) => {
  const groups = value.filter((item) => item.kind === PickerItemKind.Group);
  const groupUuids = groups.map((group) => group.uuid);

  const preview = useGroupLicencePreview(
    groupUuids,
    async () => (await API.schedules.previewAssigneeGroups({ assignedGroups: groupUuids })()).data
  );

  if (!preview) return null;

  return (
    <LicenceCoverageNotice
      surface={LicenceNoticeSurface.AuditSchedule}
      total={preview.total}
      licensed={preview.licensed}
      groupNames={groups.map((group) => group.name)}
      groupSelectionChanged={
        !savedValue || groupSelectionKey(groupUuids) !== groupSelectionKey(groupUuidsOf(savedValue))
      }
      testId={dataTestId}
    />
  );
};

export default GroupLicenceNotice;
